//#region \0rolldown/runtime.js
var e = Object.defineProperty, t = (t, n) => {
	let r = {};
	for (var i in t) e(r, i, {
		get: t[i],
		enumerable: !0
	});
	return n || e(r, Symbol.toStringTag, { value: "Module" }), r;
};
//#endregion
//#region src/persistence.ts
function n(e) {
	return Array.isArray(e) ? e.filter((e) => e != null) : [];
}
function r(e) {
	let t = [...e];
	for (let e = t.length - 1; e > 0; e--) {
		let n = Math.floor(Math.random() * (e + 1));
		[t[e], t[n]] = [t[n], t[e]];
	}
	return t;
}
function i(e) {
	return e == null ? !0 : Array.isArray(e) ? e.length === 0 : typeof e == "object" && Object.keys(e).length === 0;
}
async function a(e, t, a, o = "value") {
	let s = n(t?.data?.shuffledValues ?? t?.shuffledValues ?? []);
	if (!t) {
		console.warn("Unable to save shuffled choices because there's no session.");
		return;
	}
	if (!i(s)) return n(s.map((t) => e.find((e) => e[o] === t)));
	let c = r(e);
	if (a && typeof a == "function") try {
		let e = n(c.map((e) => e[o]));
		i(e) ? console.error(`shuffledValues is an empty array - refusing to call updateSession. shuffledChoices: ${JSON.stringify(c)}, key: ${o}`) : await a(t.id, t.element, { shuffledValues: e });
	} catch (e) {
		console.warn("Unable to save shuffled order for choices"), console.error(e);
	}
	else console.warn("Unable to save shuffled choices, shuffle will happen every time.");
	return c;
}
function o(e, t, n) {
	return !!(e.lockChoiceOrder || n?.["@pie-element"]?.lockChoiceOrder);
}
//#endregion
//#region src/partial-scoring.ts
var s = /* @__PURE__ */ t({ enabled: () => c });
function c(e, t, n) {
	return e?.partialScoring === !1 || t?.partialScoring === !1 ? !1 : typeof n != "boolean" || n;
}
//#endregion
export { a as getShuffledChoices, o as lockChoices, s as partialScoring };
